import { render, staticRenderFns } from "./Policy-ShippingFee.vue?vue&type=template&id=5a81770a"
import script from "./Policy-ShippingFee.js?vue&type=script&lang=js&external"
export * from "./Policy-ShippingFee.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports